import type { FC, ReactNode } from 'react';

export const StatCard: FC<{ label: string; value: string; variant?: string }> = ({
  label,
  value,
  variant = 'primary',
}) => (
  <div className="col">
    <div className={`card border-${variant} h-100`}>
      <div className="card-body text-center py-3">
        <div className="text-muted small">{label}</div>
        <div className="fs-4 fw-bold">{value}</div>
      </div>
    </div>
  </div>
);

export const ChartCard: FC<{ title: string; height?: number; children: ReactNode }> = ({
  title,
  height = 220,
  children,
}) => (
  <div className="card mb-3">
    <div className="card-body">
      <h6 className="card-title text-muted mb-2">{title}</h6>
      <div style={{ height }}>{children}</div>
    </div>
  </div>
);
